import { SEARCH, SEARCH_ICONS, SEARCH_ICON_COLLECTIONS } from "data/links";
import {
    heroSearchPlaceholderIcons,
    heroSearchPlaceholderPhotos
} from "./data";

import breakpoints from "core/breakpoints";

// for search input placeholder text:

export const placeholderText = ({ browserWidth, isPhotos = false }) => {
    let placeholder;

    const placeholderType = isPhotos
        ? heroSearchPlaceholderPhotos
        : heroSearchPlaceholderIcons;

    if (browserWidth > breakpoints.beforeDesktop.px) {
        // desktop hero search placeholder:
        placeholder = placeholderType.desktop;
    } else if (browserWidth > breakpoints.beforeTablet.px) {
        // tablet hero search placeholder:
        placeholder = placeholderType.tablet;
    } else {
        // mobile hero search placeholder:
        placeholder = placeholderType.mobile;
    }

    return placeholder;
};

export const searchURLPath = ({ currentPath, searchType }) => {
    let path;

    if (searchType === "Photos") {
        // ^^ if selected toggle button === photos:
        path = SEARCH;
    } else if (searchType === "Icons") {
        // ^^ if selected toggle button === icons:

        if (currentPath === SEARCH_ICON_COLLECTIONS) {
            // ^^ if the page user is on is collection page:
            path = SEARCH_ICON_COLLECTIONS;
        } else {
            path = SEARCH_ICONS;
        }
    } else {
        throw new Error(`Unknown search type "${searchType}"`);
    }

    return path;
};
